// extracted by mini-css-extract-plugin
export default {"orderTable__body_row":"OrderCartItem_orderTable__body_row__hpflM","orderTable__body_row_elem":"OrderCartItem_orderTable__body_row_elem__C+9TE"};